<h4 mat-dialog-title></h4>

<mat-dialog-content>
    <div>
        <label>Contacts</label>
        <kendo-multiselect [data]="contacts"
                           [textField]="'name'"
                           [valueField]="'email'"
                           [(ngModel)]="selectedContacts"
                           (valueChange)="selectionChanged()"
                           [popupSettings]="{ appendTo: 'component' }">
        </kendo-multiselect>
    </div>

    <div>
        <label>Additional Emails</label>
        <span matTooltip="Enter multple emails separated by a comma (',')"><i class="far fa-question-circle text-primary"></i></span>
        <input type="text" class="form-control" [ngModel]="typedEmails" (input)="emailsOnChange($event.target.value)" />
        <label class="text-danger">WARNING</label>: Do not send to any distribution list if any of those emails are included in the Employees or Additional Emails.
    </div>
</mat-dialog-content>

<mat-dialog-actions>
</mat-dialog-actions>
